export default "__VITE_ASSET__04c3c579__"